import { PricingMatrixResponse } from './types';

const API_BASE_URL = '/api/experiences';

export const fetchPricingMatrix = async (
  experienceId: string | number,
  date: string
): Promise<PricingMatrixResponse> => {
  if (!experienceId || !date) {
    throw new Error('Experience ID and date are required');
  }

  const response = await fetch(
    `${API_BASE_URL}/${experienceId}/time-slots?date=${date}`
  );

  if (!response.ok) {
    throw new Error('Failed to fetch pricing matrix');
  }

  return response.json();
};
